export default __webpack_public_path__ + "static/media/cert-it-HKIRC.2aa9a6ea.jpg";